<template>
  <div class="index-foot">
    <div class="links-title"><img style="width:350px" src="./../assets/images/logo_name.png" /></div>
    <div class="links-list">
      <a
        class="link"
        v-for="(item, index) in linksList"
        :key="index"
        :href="item.linkUrl"
        target="blank"
        >
        {{ item.linkName }}
      </a>
      <a href="javascript:;" @click="toLogin" style="color:#fff;">平台管理</a>
    </div>
    <!-- <div class="copy-right">
      版权归上海卓越睿新技术有限公司所有 沪ICP证10007183
    </div> -->
  </div>
</template>
<script>
// import {
//   getLoginUUId,
// } from "../plugins/cookie";
export default {
  computed: {
    userInfo: function () {
      return this.$store.state.userInfo;
    },
  },
  data() {
    return {
      linksList: [],
      isAdmin: true,
    };
  },
  created() {
    this.getLinks();
    // this.getLoginInfo();
  },
  methods: {
    async getLinks() {
      const links = await this.$get("/fore/newsType/findLinks");
      this.linksList = links;
    },
    toLogin() {
      let url = window.location.href;
      url = encodeURI(url);
      window.location.href ="https://passport.zhihuishu.com/login?source=3&service=" + url;
    },
    // async getLoginInfo() {

    //   if (!getLoginUUId()) {
    //     this.isAdmin = false;
    //     return;
    //   }
    //   const res = await this.$get("userfore/getLoginInfo", {
    //     uuid: getLoginUUId(),
    //   });
    //   this.isAdmin = !!res.manageAuthor;
    // },

  },
};
</script>    
<style scoped>
.index-foot {
  text-align: center;
  padding: 30px 0 20px 0;
}
.index-foot .links-title {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  line-height: 28px;
}
.sub-title {
  font-size: 10px;
  font-weight: 500;
  color: #fff;
  line-height: 28px;
  letter-spacing: 1px;
}
.index-foot .links-list {
  margin:40px auto;
  width:1400px;
}
.index-foot .link {
  display: inline-block;
  padding: 0 20px;
  color: #fff;
}
.index-foot .link:not(:last-child) {
  border-right: solid 1px #fff;
}
.index-foot .link a {
  color: #fff;
}
.index-foot .copy-right {
  color: #fff;
  font-size: 12px;
}
</style>